import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    name: 'home',
    path: '/',
    redirect: { name: 'device-index' },
  },
  {
    name: 'device',
    path: '/devices',
    component: () => import('@/devices/DeviceRoute.vue'),
    children: [
      {
        name: 'device-index',
        path: 'index',
        component: () => import('@/devices/index/DeviceIndexRoute.vue'),
      },
      {
        name: 'device-group-show',
        path: 'group/:deviceGroupId',
        props: true,
        component: () =>
          import('@/devices/show-group/DeviceGroupShowRoute.vue'),
      },
      {
        name: 'device-show',
        path: ':deviceId',
        props: true,
        component: () => import('@/devices/show/DeviceShowRoute.vue'),
      },
    ],
  },
  {
    name: 'tags',
    path: '/tags',
    component: {
      render (h) {
        return h('router-view');
      },
    },
    children: [
      {
        name: 'tags-index',
        path: 'index',
        component: () => import('@/tags/TagsIndexRoute.vue'),
      },
    ],
  },
  {
    name: 'users',
    path: '/users',
    component: {
      render (h) {
        return h('router-view');
      },
    },
    children: [
      {
        name: 'users-index',
        path: 'index',
        component: () => import('@/users/UsersIndexRoute.vue'),
      },
    ],
  },
  {
    name: 'library',
    path: '/library',
    component: () => import('@/library/LibraryRoute.vue') as any,
    children: [
      {
        name: 'library-index',
        path: 'index',
        component: () => import('@/library/LibraryIndexRoute.vue') as any,
      },
      {
        name: 'library-show',
        path: ':gameId',
        props: true,
        component: () => import('@/library/LibraryShowRoute.vue') as any,
      },
      {
        name: 'content-add',
        path: 'new',
        component: () => import('@/library/ContentAddRoute.vue') as any,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;

export function useRouter (): VueRouter {
  return router;
}
